import script from "./AisDataProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./AisDataProperties.vue?vue&type=script&setup=true&lang=ts"

import "./AisDataProperties.vue?vue&type=style&index=0&id=0864f2ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0864f2ac"]])

export default __exports__